import styled from '@emotion/styled'

import { NativeLink, spacing } from 'main/ui'

export const Container = styled.div`
  display: inline-flex;
`

export const HandbookNativeLink = styled(NativeLink)`
  margin-left: ${spacing.majorScale(1)}px;
`
